/**
 * GraphQL documents for the Alchemize (smart-create) playlist flow.
 *
 * - ALCHEMIZE_PLAYLIST_QUERY: backend schema lives at
 *   gaia-brooklyn-api/lib/services/alchemize-playlist/schema.gql; types are
 *   pre-generated in lib/graphql-types.ts (AlchemizePlaylistInput / Video).
 *   Returns the LLM-curated videos[], narrative, and suggestedName.
 *
 * - PLAYLIST_CREATE_WITH_ITEMS_MUTATION: atomic playlist-with-items create
 *   (replaces the prior two-step playlistCreate + N × playlistCreatePlaylistItem
 *   flow). Backend stores `items` in array order — first element = first
 *   position in the playlist — so callers should pass items in the desired
 *   display order. The mutation is @auth-gated on the backend; consumers
 *   wire JWT via `useMutation(..., { context: { jwt } })`.
 */

import { gql } from '@apollo/client'

export const ALCHEMIZE_PLAYLIST_QUERY = gql`
  query AlchemizePlaylist($input: AlchemizePlaylistInput!) {
    alchemizePlaylist(input: $input) {
      videos {
        id
        contentId
        contentType
        title
        shortDescription
        durationSeconds
        instructor
        seriesTitle
        episodeNumber
        seasonNumber
        thumbnailUrl
        path
      }
      narrative
      suggestedName
    }
  }
`

export const PLAYLIST_CREATE_WITH_ITEMS_MUTATION = gql`
  mutation PlaylistCreateWithItems(
    $playlist: PlaylistCreatePlaylistInput
    $items: [PlaylistCreateWithItemsItemInput!]!
  ) {
    playlistCreateWithItems(playlist: $playlist, items: $items) {
      playlist {
        id
        uid
        playlistType
        playlistName
      }
      playlistItems {
        id
        contentId
        playlistPosition
      }
    }
  }
`
